import logo from './logo.svg';
import './App.css';
import GantasoftApp from './components/gantasoft';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <GantasoftApp  className="mobile-nav-active"/>
    </BrowserRouter>
  
  );
}

export default App;
